module.exports = __webpack_public_path__ + "static/media/30x30-8.ec989c68.png";